// basepath
export const liveApi2 = process.env.VUE_APP_LIVE_PATH;
export const userApi2 = process.env.VUE_APP_USER_PATH;
export const payApi2 = process.env.VUE_APP_PAY_PATH;
export const videoApi2 = process.env.VUE_APP_VIDEO_PATH;
export const activityApi2 = process.env.VUE_APP_ACTIVITY_PATH;
export const mallApi2 = process.env.VUE_APP_MALL_PATH;
export const indexApi2 = process.env.VUE_APP_INDEX_PATH;
export const ssApi2 = process.env.VUE_APP_SS_PATH;
export const hostPath = process.env.VUE_APP_HOST_PATH;
export const hostPCPath = process.env.VUE_APP_HOST_PC_PATH;
export const oldHostPath = process.env.VUE_APP_OLD_HOST_PATH;
export const meetingApi2 = process.env.VUE_APP_MEETING_PATH;
export const api2 = process.env.VUE_APP_API_PATH;
export const gw = process.env.VUE_APP_GETWAY_PATH;
export const data = process.env.VUE_APP_DATA_PATH;
export const imgPath = process.env.VUE_APP_IMG_PATH;
export const wsUrl = process.env.VUE_APP_SOCKET_PATH;
export const exercisePath = process.env.VUE_APP_EXERCISE_PATH;
export const staticPath = process.env.VUE_APP_STATIC_PATH;
export const PdfJSUrl = process.env.VUE_APP_PDFJS_URL;
export const orderApi2 = process.env.VUE_APP_ORDER_PATH;
